<template>
  <div>
    <b-button-group>
      <b-button
        :class="
          (showMetadata ? 'td-btn-teal' : 'td-btn-outline-teal') + ' mr-1'
        "
        size="sm"
        pill
        :disabled="isFinishProcessChoosenData === false"
        @click="toggleMetadata"
      >
        <b-icon icon="tags" /> Metadata</b-button
      >

      <b-dropdown
        toggle-class="td-btn-outline-teal mr-1 rounded-pill"
        menu-class="td-border-grey py-3"
        size="sm"
        :disabled="isFinishProcessChoosenData === false"
        no-flip
        left
      >
        <template #button-content>
          <b-icon icon="grid1x2" font-scale="0.95" shift-v="3" />
          Layout
        </template>

        <b-dropdown-item-button
          button-class="td-btn-outline-teal font-weight-bolder td-border-transparent"
          v-b-modal="'tabel-dinamis-fields-layouting-modal'"
        >
          <b-icon icon="puzzle" /> Fields Layouting
        </b-dropdown-item-button>

        <b-dropdown-text style="width: 225px !important">
          <b-row align-v="center">
            <b-col class="td-text-teal font-weight-bolder">Freeze Table</b-col>
            <b-col class="px-0" cols="2">
              <toggle-button
                class="m-0"
                :sync="true"
                :value="isFreeze"
                :width="35"
                @change="updateIsFreeze"
              />
            </b-col>
          </b-row>
        </b-dropdown-text>
      </b-dropdown>

      <b-dropdown
        toggle-class="td-btn-outline-teal mr-1 rounded-pill"
        menu-class="td-border-grey py-3"
        size="sm"
        :disabled="isFinishProcessChoosenData === false"
        no-flip
        left
      >
        <template #button-content>
          <b-icon icon="brush" font-scale="0.95" shift-v="3" />
          Format
        </template>

        <b-dropdown-form class="td-text-teal">
          <b-icon icon="droplet-fill" /><span class="font-weight-bolder"
            >Table Theme</span
          >

          <b-table-simple class="my-2" :bordered="false" borderless>
            <b-tbody>
              <b-tr>
                <b-td>
                  <b-button
                    :class="
                      (tableTheme === 'blue'
                        ? 'td-btn-selected-table-theme-blue'
                        : '') + ' td-btn-blue w-100'
                    "
                    style="height: 1.5rem"
                    @click="updateTableTheme('blue')"
                  />
                </b-td>
                <b-td>
                  <b-button
                    :class="
                      (tableTheme === 'teal'
                        ? 'td-btn-selected-table-theme-teal'
                        : '') + ' td-btn-teal w-100'
                    "
                    style="height: 1.5rem"
                    @click="updateTableTheme('teal')"
                  />
                </b-td>
                <b-td>
                  <b-button
                    :class="
                      (tableTheme === 'orange'
                        ? 'td-btn-selected-table-theme-orange'
                        : '') + ' td-btn-orange w-100'
                    "
                    style="height: 1.5rem"
                    @click="updateTableTheme('orange')"
                  />
                </b-td>
              </b-tr>
              <b-tr>
                <b-td>
                  <b-button
                    :class="
                      (tableTheme === 'green'
                        ? 'td-btn-selected-table-theme-green'
                        : '') + ' td-btn-green w-100'
                    "
                    style="height: 1.5rem"
                    @click="updateTableTheme('green')"
                  />
                </b-td>
                <b-td>
                  <b-button
                    :class="
                      (tableTheme === 'grey'
                        ? 'td-btn-selected-table-theme-grey'
                        : '') + ' td-btn-grey w-100'
                    "
                    style="height: 1.5rem"
                    @click="updateTableTheme('grey')"
                  />
                </b-td>
                <b-td>
                  <b-button
                    :class="
                      (tableTheme === 'black'
                        ? 'td-btn-selected-table-theme-black'
                        : '') + ' td-btn-black w-100'
                    "
                    style="height: 1.5rem"
                    @click="updateTableTheme('black')"
                  />
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-dropdown-form>

        <b-dropdown-form class="td-text-teal">
          <b-row align-v="center">
            <b-col class="font-weight-bolder">
              <b-icon icon="fonts" />Font Size
            </b-col>
            <b-col class="px-0 text-right">
              <a
                :class="
                  (fontSize === 's' ? 'text-dark' : 'td-text-mid-grey') +
                  ' mr-1'
                "
                style="font-size: 12pt !important; font-weight: 1000 !important"
                v-b-tooltip.hover
                title="small"
                @click="updateFontSize('s')"
                >A</a
              >
              <a
                :class="
                  (fontSize === 'm' ? 'text-dark' : 'td-text-mid-grey') +
                  ' mr-1'
                "
                style="font-size: 16pt !important; font-weight: 1000 !important"
                v-b-tooltip.hover
                title="medium"
                @click="updateFontSize('m')"
              >
                A
              </a>
              <a
                :class="
                  (fontSize === 'l' ? 'text-dark' : 'td-text-mid-grey') +
                  ' mr-1'
                "
                style="font-size: 20pt !important; font-weight: 1000 !important"
                v-b-tooltip.hover
                title="large"
                @click="updateFontSize('l')"
                >A</a
              >
            </b-col>
          </b-row>
        </b-dropdown-form>

        <b-dropdown-text style="width: 225px !important">
          <b-row align-v="center">
            <b-col class="td-text-teal font-weight-bolder">
              <b-icon icon="distribute-vertical" /> Stripped Table
            </b-col>
            <b-col class="px-0" cols="2">
              <toggle-button
                class="m-0"
                :sync="true"
                :value="isStripped"
                :width="35"
                @change="updateIsStripped"
              />
            </b-col>
          </b-row>
        </b-dropdown-text>

        <b-dropdown-text style="width: 225px !important">
          <b-row align-v="center">
            <b-col class="td-text-teal font-weight-bolder">
              <b-icon icon="brightness-high" /> Highlight Row
            </b-col>
            <b-col class="px-0" cols="2">
              <toggle-button
                class="m-0"
                :sync="true"
                :value="isHighlighted"
                :width="35"
                @change="updateIsHighlighted"
              />
            </b-col>
          </b-row>
        </b-dropdown-text>
      </b-dropdown>

      <b-dropdown
        toggle-class="td-btn-outline-teal mr-1 rounded-pill"
        menu-class="td-border-grey py-3"
        size="sm"
        :disabled="isFinishProcessChoosenData === false"
        no-flip
        right
      >
        <template #button-content>
          <b-icon icon="tools" font-scale="0.95" shift-v="3" /> Tools
        </template>

        <b-dropdown-form class="td-text-teal" style="width: 300px !important">
          <b-row align-v="center">
            <b-col class="td-text-teal font-weight-bolder">
              <b-icon icon="calculator" /> Statistics
            </b-col>
          </b-row>

          <b-row class="ml-1 my-1">
            <b-col>>Sum </b-col>
            <b-col class="px-0" cols="3">
              <toggle-button
                class="m-0"
                :sync="true"
                :value="doSum"
                :width="35"
                @change="toggleDoSum"
              />
            </b-col>
          </b-row>

          <b-row class="ml-1 my-1">
            <b-col>>Average </b-col>
            <b-col class="px-0" cols="3">
              <toggle-button
                class="m-0"
                :sync="true"
                :value="doAverage"
                :width="35"
                @change="toggleDoAverage"
              />
            </b-col>
          </b-row>

          <b-row class="ml-1 my-1">
            <b-col>>Minimum </b-col>
            <b-col class="px-0" cols="3">
              <toggle-button
                class="m-0"
                :sync="true"
                :value="doMinimum"
                :width="35"
                @change="toggleDoMinimum"
              />
            </b-col>
          </b-row>

          <b-row class="ml-1 my-1">
            <b-col>>Maximum </b-col>
            <b-col class="px-0" cols="3">
              <toggle-button
                class="m-0"
                :sync="true"
                :value="doMaximum"
                :width="35"
                @change="toggleDoMaximum"
              />
            </b-col>
          </b-row>

          <b-row class="ml-1 my-1">
            <b-col>>Median </b-col>
            <b-col class="px-0" cols="3">
              <toggle-button
                class="m-0"
                :sync="true"
                :value="doMedian"
                :width="35"
                @change="toggleDoMedian"
              />
            </b-col>
          </b-row>

          <b-row class="ml-1 my-1">
            <b-col>>Count </b-col>
            <b-col class="px-0" cols="3">
              <toggle-button
                class="m-0"
                :sync="true"
                :value="doCount"
                :width="35"
                @change="toggleDoCount"
              />
            </b-col>
          </b-row>

          <b-row class="ml-1 my-1">
            <b-col>>Standard Deviation </b-col>
            <b-col class="px-0" cols="3">
              <toggle-button
                class="m-0"
                :sync="true"
                :value="doStandardDeviation"
                :width="35"
                @change="toggleDoStandardDeviation"
              />
            </b-col>
          </b-row>
        </b-dropdown-form>

        <b-dropdown-divider />

        <b-dropdown-form class="td-text-teal" style="width: 300px !important">
          <b-row align-v="center">
            <b-col class="td-text-teal font-weight-bolder">
              <b-icon icon="stoplights" /> Highlight
            </b-col>
          </b-row>

          <b-row class="ml-1 my-1">
            <b-col>>Minimum-X </b-col>
            <b-col class="px-0" cols="3">
              <toggle-button
                class="m-0"
                :sync="true"
                :value="doMinimumX"
                :width="35"
                @change="toggleDoMinimumX"
              />
            </b-col>
          </b-row>

          <b-row class="ml-1 my-1">
            <b-col>>Maximum-X </b-col>
            <b-col class="px-0" cols="3">
              <toggle-button
                class="m-0"
                :sync="true"
                :value="doMaximumX"
                :width="35"
                @change="toggleDoMaximumX"
              />
            </b-col>
          </b-row>

          <b-row class="ml-1 my-1">
            <b-col>>Minimum-Y </b-col>
            <b-col class="px-0" cols="3">
              <toggle-button
                class="m-0"
                :sync="true"
                :value="doMinimumY"
                :width="35"
                @change="toggleDoMinimumY"
              />
            </b-col>
          </b-row>

          <b-row class="ml-1 my-1">
            <b-col>>Maximum-Y </b-col>
            <b-col class="px-0" cols="3">
              <toggle-button
                class="m-0"
                :sync="true"
                :value="doMaximumY"
                :width="35"
                @change="toggleDoMaximumY"
              />
            </b-col>
          </b-row>
        </b-dropdown-form>
      </b-dropdown>

      <b-button
        class="td-btn-outline-teal mr-1"
        size="sm"
        pill
        :disabled="isFinishProcessChoosenData === false"
        @click="resetTable"
      >
        <b-icon icon="arrow-counterclockwise" font-scale="0.95" shift-v="3" />
        Reset</b-button
      >

      <b-button
        class="td-btn-outline-teal mr-1"
        size="sm"
        pill
        :disabled="isFinishProcessChoosenData === false"
        @click="toggleFullScreen"
      >
        <b-icon
          :icon="isFullScreen ? 'zoom-out' : 'zoom-in'"
          font-scale="0.95"
          shift-v="3"
        />
        Fullscreen</b-button
      >

      <!-- <b-button
				class="td-btn-outline-teal mr-1"
				size="sm"
				pill
				:disabled="isFinishProcessChoosenData === false"
				@click="print"
			>
				<b-icon icon="printer" /> Cetak</b-button
			> -->

      <b-dropdown
        id="download-dropdown"
        toggle-class="td-btn-outline-teal mr-1 rounded-pill"
        menu-class="td-border-grey"
        size="sm"
        :disabled="isFinishProcessChoosenData === false"
        right
        no-flip
      >
        <template #button-content> <b-icon icon="download" /> Unduh </template>

        <b-dropdown-item-button
          button-class="td-btn-outline-orange td-border-transparent"
          @click="downloadCSV"
          @click.stop.prevent
        >
          <b-icon icon="file-text" /> CSV
        </b-dropdown-item-button>

        <b-dropdown-item-button
          button-class="td-btn-outline-green td-border-transparent"
          @click="downloadExcel"
        >
          <b-icon icon="file-excel" />
          Excel
        </b-dropdown-item-button>

        <b-dropdown-item-button
          button-class="td-btn-outline-blue td-border-transparent"
          @click="downloadJSON"
        >
          <b-icon icon="file-check" /> JSON
        </b-dropdown-item-button>

        <b-dropdown-item-button
          button-class="td-btn-outline-red td-border-transparent"
          @click="downloadPDF"
        >
          <b-icon icon="file-post" /> PDF
        </b-dropdown-item-button>

        <b-dropdown-item-button
          button-class="td-btn-outline-teal td-border-transparent"
          @click="downloadXML"
        >
          <b-icon icon="file-code" />
          XML
        </b-dropdown-item-button>
      </b-dropdown>
    </b-button-group>

    <visualization-fields-layouting-modal
      :choosenRowFields="choosenRowFields"
      :choosenColumnFields="choosenColumnFields"
      :choosenDimensions="choosenDimensions"
      :updateIsNeedReloaded="updateIsNeedReloaded"
      :updateChoosenRowFields="updateChoosenRowFields"
      :updateChoosenColumnFields="updateChoosenColumnFields"
    />
  </div>
</template>

<!-- javascript section-->
<script>
//import js modules section
import VisualizationFieldsLayoutingModal from "./VisualizationTableMenuBar/VisualizationFieldsLayoutingModal.vue";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import jszip from "jszip";
import services from "../../../../../../../services/TabelDinamisServicesV3";
import utils from "../../../../../../../utils/TabelDinamisUtils";
// import WebWorkerApi from "../../../../../../../webworkers/tabel-dinamis/WebWorkerApi.js";

//local registration for output component
export default {
  name: "VisualizationTableMenuBar",
  data() {
    return {
      isFullScreen: false,
      excelStyle: null,
    };
  },
  props: [
    "isFinishProcessChoosenData",
    "choosenData",
    "datasetTitle",
    "accessTime",
    "isFreeze",
    "isStripped",
    "isHighlighted",
    "showMetadata",
    "choosenRowFields",
    "choosenColumnFields",
    "choosenDimensions",
    "updateIsNeedReloaded",
    "fontSize",
    "tableTheme",
    "updateChoosenRowFields",
    "updateChoosenColumnFields",
    "doSum",
    "doAverage",
    "doMinimum",
    "doMaximum",
    "doMedian",
    "doCount",
    "doStandardDeviation",
    "doMinimumX",
    "doMaximumX",
    "doMinimumY",
    "doMaximumY",
    "selectedDataList",
    "choosenDataIdx",
  ],
  created() {},
  destroyed() {},
  mounted() {
    document.addEventListener(
      "webkitfullscreenchange",
      this.exitHandler,
      false
    );
    document.addEventListener("mozfullscreenchange", this.exitHandler, false);
    document.addEventListener("fullscreenchange", this.exitHandler, false);
    document.addEventListener("MSFullscreenChange", this.exitHandler, false);

    this.getExcelStyle();
  },
  computed: {
    filename() {
      return (
        this.datasetTitle.replace(/\//g, " ⁄ ") +
        " - Sumber: Indah BPS - Tabel Dinamis, Waktu Akses: " +
        this.reformatTimeForFilename(this.accessTime)
      );
    },
    subjectMetadata() {
      return this.choosenDataIdx == null || this.choosenDataIdx < 0
        ? ""
        : this.selectedDataList[this.choosenDataIdx].selectedSubject;
    },
    datasetMetadata() {
      return this.choosenDataIdx == null || this.choosenDataIdx < 0
        ? ""
        : this.selectedDataList[this.choosenDataIdx].selectedDataset;
    },
    indicatorMetadata() {
      return this.choosenDataIdx == null || this.choosenDataIdx < 0
        ? ""
        : this.selectedDataList[this.choosenDataIdx].selectedIndicator;
    },
    dimensionMetadata() {
      return this.choosenDataIdx == null || this.choosenDataIdx < 0
        ? ""
        : this.selectedDataList[this.choosenDataIdx].selectedDimension;
    },
    regionDimensionIdx() {
      if (this.dimensionMetadata === "") {
        return null;
      } else {
        return this.dimensionMetadata.findIndex(
          (item) => item.role.toLowerCase() === "region"
        );
      }
    },
    optionsRegionDimension() {
      if (this.regionDimensionIdx == null) {
        return "";
      } else {
        return this.dimensionMetadata[this.regionDimensionIdx];
      }
    },
    optionsRegionUnited() {
      switch (this.optionsRegionDimension.selectedRegionLevel) {
        case "NationalByProvince":
        case "ProvinceByDistrict":
          return this.optionsRegionDimension.selectedItemDimension;

        case "DistrictBySubdistrict":
          if (this.optionsRegionDimension.selectedProvince === "") {
            return this.optionsRegionDimension.selectedItemDimension;
          } else {
            let temp = [];
            temp.push(this.optionsRegionDimension.selectedProvince);
            return temp.concat(
              this.optionsRegionDimension.selectedItemDimension
            );
          }

        case "SubdistrictByVillage":
          if (
            this.optionsRegionDimension.selectedProvince === "" &&
            this.optionsRegionDimension.selectedDistrict === ""
          ) {
            return this.optionsRegionDimension.selectedItemDimension;
          } else if (
            this.optionsRegionDimension.selectedProvince === "" &&
            this.optionsRegionDimension.selectedDistrict !== ""
          ) {
            let temp = [];
            temp.push(this.optionsRegionDimension.selectedDistrict);
            return temp.concat(
              this.optionsRegionDimension.selectedItemDimension
            );
          } else if (
            this.optionsRegionDimension.selectedProvince !== "" &&
            this.optionsRegionDimension.selectedDistrict !== ""
          ) {
            let temp = [];
            temp.push(this.optionsRegionDimension.selectedProvince);
            temp.push(this.optionsRegionDimension.selectedDistrict);
            return temp.concat(
              this.optionsRegionDimension.selectedItemDimension
            );
          } else {
            return null;
          }
        default:
          return null;
      }
    },
  },
  watch: {},
  methods: {
    exitHandler() {
      if (
        !document.webkitIsFullScreen &&
        !document.mozFullScreen &&
        !document.msFullscreenElement
      ) {
        this.isFullScreen = false;
      }
    },
    toggleFullScreen() {
      if (
        (document.fullScreenElement && document.fullScreenElement !== null) ||
        (!document.mozFullScreen && !document.webkitIsFullScreen)
      ) {
        if (document.documentElement.requestFullScreen) {
          document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          /* Firefox */
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
          /* Chrome, Safari & Opera */
          document.documentElement.webkitRequestFullScreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        } else if (document.msRequestFullscreen) {
          /* IE/Edge */
          document.documentElement.msRequestFullscreen();
        }
        this.isFullScreen = true;
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          /* Firefox */
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          /* Chrome, Safari and Opera */
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          /* IE/Edge */
          document.msExitFullscreen();
        }
        this.isFullScreen = false;
      }
    },
    reformatTimeForFilename(str) {
      return str.replace(/:/g, "_");
    },

    /*print methods section */
    print() {
      let printWindow = window.open("", "_blank");
      printWindow.document.write(this.generateHtmlTablePrint());
      printWindow.document.close();
      printWindow.focus();
      printWindow.onload = function () {
        printWindow.print();
        printWindow.close();
      };
    },
    generateHtmlTablePrint() {
      let title = document.getElementById(
        "tabel-dinamis-choosen-dataset-title"
      ).outerHTML;
      let table = document
        .getElementById("tabel-dinamis-choosen-dataset-pivot-table")
        .outerHTML.replace("b-table-sticky-header", "")
        .replace('style="position: sticky; top: 0px; z-index: 3;"', "");
      let info = document.getElementById(
        "tabel-dinamis-choosen-dataset-info"
      ).outerHTML;

      let metadata = "";
      if (this.showMetadata) {
        metadata =
          '<div id="tabel-dinamis-visualization-table-metadata" class="mt-4" style="scroll-margin-top: 70px;">';

        metadata += document
          .querySelector(
            "#tabel-dinamis-visualization-table-metadata>div.card:nth-child(1)"
          )
          .outerHTML.trim();

        metadata += document
          .querySelector(
            "#tabel-dinamis-visualization-table-metadata>div.card:nth-child(2)"
          )
          .outerHTML.trim();

        /*indicator */
        metadata +=
          '<div class="card my-4"> ' +
          '<div class="card-header td-bg-light-orange td-text-orange td-border-orange td-border-solid td-border-thin">' +
          '<h5 class="m-0">Metadata Indikator</h5>' +
          "</div>";

        metadata +=
          '<div class="card-body td-border-orange td-border-solid td-border-thin">';

        let metadataIndicatorContainer = document.getElementsByClassName(
          "metadata-indicator-container"
        );
        Object.entries(metadataIndicatorContainer).forEach(([index, item]) => {
          item.style.display = "";
          metadata += item.outerHTML;
          metadata +=
            index < metadataIndicatorContainer.length - 1
              ? "<hr class='my-3' style='box-sizing: content-box; border: 0; height: 0; margin: .5rem 0; overflow: hidden; border-top: 1.5px solid #e9ecef;'>"
              : "";
        });
        metadata += "</div> </div>";

        /*dimension */
        metadata +=
          '<div class="card my-4"> ' +
          '<div class="card-header td-bg-light-green td-text-green td-border-green td-border-solid td-border-thin">' +
          '<h5 class="m-0">Metadata Dimensi</h5>' +
          "</div>";

        metadata +=
          '<div class="card-body td-border-green td-border-solid td-border-thin">';

        let metadataDimensionContainer = document.getElementsByClassName(
          "metadata-dimension-container"
        );
        Object.entries(metadataDimensionContainer).forEach(([index, item]) => {
          item.style.display = "";
          metadata += item.outerHTML;
          metadata +=
            index < metadataDimensionContainer.length - 1
              ? "<hr class='my-3' style='box-sizing: content-box; border: 0; height: 0; margin: .5rem 0; overflow: hidden; border-top: 1.5px solid #e9ecef;'>"
              : "";
        });

        metadata += "</div> </div>";
      }

      let output =
        "<html><head><title>" +
        document.title +
        ': Cetak Tabel Dinamis</title><link rel="icon" href="/img/logo.svg">' +
        '<link rel="stylesheet" type="text/css" href="/css/table-dinamis-print-v3.css">' +
        "</head><body>" +
        '<p id="tabel-dinamis-title"><span>Tabel</span><span>Dinamis</span><span style="font-size: 0.7rem; margin-left: 0.5rem !important;">Ver. 3.0.0</span></p>' +
        title +
        table +
        info +
        metadata +
        "</body></html>";
      return output;
    },

    generateZipFile(files, fileFormat, zipFile) {
      //compressed zip preference with compression level 9
      zipFile
        .generateAsync({
          type: "blob",
          compression: "DEFLATE",
          compressionOptions: {
            level: 9,
          },
        })
        .then((files) => {
          let downloadLink = document.createElement("a");
          let url = URL.createObjectURL(files);
          downloadLink.href = url;
          downloadLink.download =
            "(" + fileFormat + ") " + this.filename + ".zip";
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        });
    },

    /*csv methods section*/
    downloadCSV() {
      let data,
        csvFile,
        csvFilename,
        zipFile = new jszip();

      //data-csv
      data = this.flatDataJson(this.choosenData);
      csvFilename = "(data) " + this.filename + ".csv";
      csvFile = this.constructCSVFile(data, csvFilename, zipFile);

      //subject-metadata-csv
      data = [this.subjectMetadata];
      csvFilename = "(metadata subjek) " + this.filename + ".csv";
      csvFile = this.constructCSVFile(data, csvFilename, zipFile);

      //dataset-metadata-csv
      data = [this.datasetMetadata];
      csvFilename = "(metadata dataset) " + this.filename + ".csv";
      csvFile = this.constructCSVFile(data, csvFilename, zipFile);

      //dimension-metadata-csv
      data = this.dimensionMetadata;
      csvFilename = "(dimension-metadata) " + this.filename + ".csv";
      csvFile = this.constructCSVFile(data, csvFilename, zipFile);

      this.generateZipFile(csvFile, "csv", zipFile);
    },
    constructCSVFile(data, filename, zipFile) {
      let blob,
        header = Object.keys(data[0]);
      let replacer = (key, value) => (value === null ? "" : value);

      let csvContent = [
        header.join(","),
        ...data.map((row) =>
          header
            .map((fieldName) => {
              if (row[fieldName] != null) {
                let string = JSON.stringify(row[fieldName], replacer).replace(
                  /\\"/g,
                  '""'
                );

                if (Array.isArray(row[fieldName])) {
                  string = '"' + string.replaceAll('"', '""') + '"';
                }

                return string;
              }
            })
            .join(",")
        ),
      ].join("\r\n");

      blob = new Blob(["\ufeff", csvContent]);

      return zipFile.file(filename, blob);
    },
    flatDataJson: function (data) {
      return Object.keys(data).map((key) => {
        return this.flattenJSON(data[key]);
      });
    },
    flattenJSON: function (data) {
      var result = {};
      function recurse(cur, prop) {
        if (Object(cur) !== cur) {
          result[prop] = cur;
        } else if (Array.isArray(cur)) {
          let l = cur.length;
          for (let i = 0; i < l; i++) {
            recurse(cur[i], prop + "[" + i + "]");
          }
          if (l === 0) {
            result[prop] = [];
          }
        } else {
          var isEmpty = true;
          for (var p in cur) {
            isEmpty = false;
            recurse(cur[p], prop ? prop + "." + p : p);
          }
          if (isEmpty && prop) result[prop] = {};
        }
      }
      recurse(data, "");

      return result;
    },

    /*excel methods section*/
    downloadExcel() {
      let data,
        excelFile,
        excelFilename,
        sheetName,
        zipFile = new jszip();

      //data-excel
      data = this.generateDataSheet();
      sheetName = "data";
      excelFilename = "(data) " + this.filename + ".xls";
      excelFile = this.constructExcelFile(
        data,
        sheetName,
        excelFilename,
        zipFile
      );

      //subject-metadata-csv
      data = this.generateMetadataSheet("subject");
      sheetName = "metadata subjek";
      excelFilename = "(metadata subjek) " + this.filename + ".xls";
      excelFile = this.constructExcelFile(
        data,
        sheetName,
        excelFilename,
        zipFile
      );

      //dataset-metadata-csv
      data = this.generateMetadataSheet("dataset");
      sheetName = "metadata dataset";
      excelFilename = "(metadata dataset) " + this.filename + ".xls";
      excelFile = this.constructExcelFile(
        data,
        sheetName,
        excelFilename,
        zipFile
      );

      //indicator-metadata-csv
      data = this.generateMetadataSheet("indicator");
      sheetName = "metadata indikator";
      excelFilename = "(metadata indikator) " + this.filename + ".xls";
      excelFile = this.constructExcelFile(
        data,
        sheetName,
        excelFilename,
        zipFile
      );

      //indicator-dimension-csv
      data = this.generateMetadataSheet("dimension");
      sheetName = "metadata dimensi";
      excelFilename = "(metadata dimensi) " + this.filename + ".xls";
      excelFile = this.constructExcelFile(
        data,
        sheetName,
        excelFilename,
        zipFile
      );

      this.generateZipFile(excelFile, "excel", zipFile);
    },
    base64: function (s) {
      return window.btoa(
        unescape(encodeURIComponent(s)) || decodeURI(encodeURIComponent(s))
      );
    },
    format: function (s, c) {
      return s.replace(/{(\w+)}/g, function (m, p) {
        return c[p];
      });
    },
    async getExcelStyle() {
      await services.getExcelStyle().then(
        (response) => {
          this.excelStyle = "<style>" + response.data + "</style>";
        },
        (error) => {
          console.log(error);
        }
      );
    },
    generateDataSheet() {
      let title, table, info, temp;

      title = document.getElementById(
        "tabel-dinamis-choosen-dataset-title"
      ).outerHTML;

      table = document
        .getElementById("tabel-dinamis-choosen-dataset-pivot-table")
        .outerHTML.replace("b-table-sticky-header", "")
        .replace('style="position: sticky; top: 0px; z-index: 3;"', "");

      info = document.getElementById(
        "tabel-dinamis-choosen-dataset-info"
      ).outerHTML;

      temp = document.createElement("temp");
      temp.innerHTML = title + table + info;

      temp
        .querySelectorAll("#tabel-dinamis-pivot-table > thead > tr")
        .forEach((tr) => {
          tr.querySelectorAll("th").forEach((th) => {
            th.classList.remove("table-b-table-default");
            th.classList.remove("b-table-sticky-column");

            th.className = th.className
              .split(" ")
              .sort()
              .reduce((total, item) => {
                return total + "-" + item;
              });

            if (th.style.display === "none") {
              th.remove();
            }
          });
        });

      temp
        .querySelectorAll("#tabel-dinamis-pivot-table > tbody > tr")
        .forEach((tr) => {
          tr.querySelectorAll("th").forEach((th) => {
            th.classList.remove("table-b-table-default");
            th.classList.remove("b-table-sticky-column");

            th.className = th.className
              .split(" ")
              .sort()
              .reduce((total, item) => {
                return total + "-" + item;
              });
          });

          tr.querySelectorAll("td").forEach((td) => {
            let classNames = td.className
              .split(" ")
              .filter((item) => item.startsWith("tabel-dinamis-"));
            td.className = classNames[classNames.length - 1];
          });
        });

      temp
        .querySelectorAll("#tabel-dinamis-pivot-table > tfoot > tr")
        .forEach((tr) => {
          tr.querySelectorAll("th").forEach((th) => {
            th.classList.remove("table-b-table-default");
            th.classList.remove("b-table-sticky-column");

            th.className = th.className
              .split(" ")
              .sort()
              .reduce((total, item) => {
                return total + "-" + item;
              });
          });

          tr.querySelectorAll("td").forEach((td) => {
            let classNames = td.className
              .split(" ")
              .filter((item) => item.startsWith("tabel-dinamis-"));
            td.className = classNames[classNames.length - 1];
          });
        });

      return temp.outerHTML;
    },
    generateMetadataSheet(metadataType) {
      let temp = "";

      switch (metadataType) {
        case "subject": {
          temp +=
            "<div><h4 class='td-text-blue'>Metadata Subjek Statistik</h4>";
          temp += "<div></div>";
          temp +=
            "<table id='tabel-dinamis-visualization-subject-metadata-container' class='tabel-dinamis-visualization-metadata-container'><thead><tr><th>Subjek Statistik</th><th>Deskripsi</th><th>Referensi</th></tr></thead><tbody><tr>";
          temp +=
            "<td style='border-left: 1px solid #428cd4 !important;'>" +
            utils.changeNullIntoStrip(this.subjectMetadata.name) +
            "</td>";
          temp += this.generateTd(
            utils.changeNullIntoStrip(this.subjectMetadata.description)
          );
          temp +=
            "<td style='border-right: 1px solid #428cd4 !important;'>" +
            this.subjectMetadata.reference +
            "</td>";
          temp += "</tr></tbody></table>";
          return temp;
        }
        case "dataset": {
          temp += "<div><h4 class='td-text-green'>Metadata Dataset</h4>";
          temp += "<div></div>";
          temp +=
            "<table id='tabel-dinamis-visualization-dataset-metadata-container' class='tabel-dinamis-visualization-metadata-container'><thead><tr><th>Dataset</th><th>Frekuensi</th><th>Jenis Data</th><th>Pemilik Data</th><th>Divisi Pengelola Data</th></tr></thead><tbody><tr>";
          temp +=
            "<td style='border-left: 1px solid #56c596 !important;'>" +
            utils.changeNullIntoStrip(this.datasetMetadata.name) +
            "</td>";
          temp += this.generateTd(
            utils.changeNullIntoStrip(this.datasetMetadata.frequency)
          );
          temp += this.generateTd(
            utils.changeNullIntoStrip(this.datasetMetadata.dataType)
          );
          temp += this.generateTd(
            utils.changeNullIntoStrip(this.datasetMetadata.owner)
          );
          temp +=
            "<td style='border-right: 1px solid #56c596 !important;'>" +
            utils.changeNullIntoStrip(this.datasetMetadata.maintainer) +
            "</td>";
          temp += "</tr></tbody></table>";
          return temp;
        }
        case "indicator": {
          temp += "<div><h4 class='td-text-orange'>Metadata Indikator</h4>";
          temp += "<div></div>";
          temp +=
            "<table id='tabel-dinamis-visualization-indicator-metadata-container' class='tabel-dinamis-visualization-metadata-container'><thead><tr><th>Indikator</th><th>Definisi</th><th>Mekanisme Perhitungan</th><th>Rumus</th><th>Manfaat</th><th>Interpretasi</th><th>Satuan</th><th>Disaggregasi</th><th>Indikator Standar</th><th>Frekuensi Update</th><th>Level Penyajian</th><th>Organisasi Penanggung Jawab</th><th>Ukuran</th><th>Konsep</th></tr></thead><tbody>";
          this.indicatorMetadata.forEach((item) => {
            temp += "<tr>";
            temp +=
              "<td style='border-left: 1px solid #56c596 !important;'>" +
              utils.changeNullIntoStrip(item.name) +
              "</td>";
            temp += this.generateTd(utils.changeNullIntoStrip(item.definition));
            temp += this.generateTd(
              utils.changeNullIntoStrip(item.calculationMechanism)
            );
            temp += this.generateTd(utils.changeNullIntoStrip(item.formula));
            temp += this.generateTd(utils.changeNullIntoStrip(item.benefit));
            temp += this.generateTd(
              utils.changeNullIntoStrip(item.interpretation)
            );
            temp += this.generateTd(
              utils.changeNullIntoStrip(item.measurementUnit)
            );
            temp += this.generateTd(
              utils.changeNullIntoStrip(item.disaggregation)
            );
            temp += this.generateTd(utils.changeNullIntoStrip(item.standard));
            temp += this.generateTd(
              utils.changeNullIntoStrip(item.updateFrequency)
            );
            temp += this.generateTd(
              utils.changeNullIntoStrip(item.presentationLevel)
            );
            temp += this.generateTd(
              utils.changeNullIntoStrip(item.responsibleOrganization)
            );
            temp += this.generateTd(
              utils.changeNullIntoStrip(item.measurement)
            );

            //concept section
            temp += "<td style='border-right: 1px solid #56c596 !important;'>";
            item.conceptList.forEach((item2) => {
              temp +=
                "-" +
                item2.concept +
                "<br style='mso-data-placement:same-cell;'/>";
            });

            temp += "</td>";
            temp += "</tr>";
          });

          temp += "</tbody></table>";
          return temp;
        }
        case "dimension": {
          temp += "<div><h4 class='td-text-green'>Metadata Dimensi</h4>";
          temp += "<div></div>";
          temp +=
            "<table id='tabel-dinamis-visualization-dimension-metadata-container' class='tabel-dinamis-visualization-metadata-container'><thead><tr><th>Dimensi</th><th>Versi Klasifikasi</th><th>Domain Nilai</th><th>Level Item Teratas</th><th>Level Item Terbawah</th><th>Daftar Item Dimensi</th></tr></thead><tbody>";
          this.dimensionMetadata.forEach((item) => {
            temp += "<tr>";
            temp +=
              "<td style='border-left: 1px solid #56c596 !important;'>" +
              utils.capitalizeEachWord(item.name) +
              "</td>";
            temp += this.generateTd(item.classificationVersion);
            temp += this.generateTd(
              utils.changeNullIntoStrip(item.dimensionValueDomainName)
            );
            temp += this.generateTd(
              utils.changeNullIntoStrip(item.initialParentLevel)
            );
            temp += this.generateTd(
              utils.changeNullIntoStrip(item.lowestLevel)
            );

            //item-dimension section
            temp += "<td style='border-right: 1px solid #56c596 !important;'>";
            if (
              item.role.toLowerCase() === "region" &&
              this.optionsRegionUnitedthis !== ""
            ) {
              this.optionsRegionUnited.forEach((item2) => {
                temp +=
                  "- (" +
                  item2.code +
                  ") " +
                  item2.name +
                  ", " +
                  item2.description +
                  "<br style='mso-data-placement:same-cell;'/>";
              });
            } else if (item.role.toLowerCase() === "dimension") {
              item.selectedItemDimension.forEach((item2) => {
                temp +=
                  "- (" +
                  item2.code +
                  ") " +
                  item2.name +
                  ", " +
                  item2.description +
                  "<br style='mso-data-placement:same-cell;'/>";
              });
            }

            temp += "</td>";
            temp += "</tr>";
          });
          temp += "</tbody></table>";
          return temp;
        }

        default:
          return "";
      }
    },
    constructExcelFile(data, sheetName, filename, zipFile) {
      let base64,
        ctx,
        // uri = "data:application/vnd.ms-excel;base64,",
        template =
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->' +
          this.excelStyle +
          '</head><body><table>{table}</table></body></html>"';

      ctx = { worksheet: sheetName || "Worxksheet", table: data };
      // base64 = uri + this.base64(this.format(template, ctx));
      base64 = this.base64(this.format(template, ctx));

      return zipFile.file(filename, base64, { base64: true });
    },

    /*json methods section*/
    downloadJSON() {
      let data,
        jsonFile,
        jsonFilename,
        zipFile = new jszip();

      //data-json
      data = JSON.stringify(this.choosenData);
      jsonFilename = "(data) " + this.filename + ".json";
      jsonFile = zipFile.file(jsonFilename, data);

      //subject-metadata-json
      data = JSON.stringify(this.subjectMetadata);
      jsonFilename = "(metadata subjek) " + this.filename + ".json";
      jsonFile = zipFile.file(jsonFilename, data);

      //dataset-metadata-json
      data = JSON.stringify(this.datasetMetadata);
      jsonFilename = "(metadata dataset) " + this.filename + ".json";
      jsonFile = zipFile.file(jsonFilename, data);

      //indicator-metadata-json
      data = JSON.stringify(this.indicatorMetadata);
      jsonFilename = "(metadata indikator) " + this.filename + ".json";
      jsonFile = zipFile.file(jsonFilename, data);

      //dimension-metadata-json
      data = JSON.stringify(this.dimensionMetadata);
      jsonFilename = "(metadata dimensi) " + this.filename + ".json";
      jsonFile = zipFile.file(jsonFilename, data);

      this.generateZipFile(jsonFile, "json", zipFile);
    },

    /*pdf methods section*/
    downloadPDF() {
      document
        .getElementById("tabel-dinamis-html-pdf-container")
        .appendChild(
          document.getElementById("tabel-dinamis-title").cloneNode(true)
        );
      document
        .getElementById("tabel-dinamis-html-pdf-container")
        .appendChild(
          document
            .getElementById("tabel-dinamis-choosen-dataset-title")
            .cloneNode(true)
        );

      document
        .getElementById("tabel-dinamis-html-pdf-container")
        .appendChild(
          document
            .getElementById("tabel-dinamis-choosen-dataset-pivot-table")
            .cloneNode(true)
        );
      document.querySelector(
        "#tabel-dinamis-html-pdf-container > #tabel-dinamis-choosen-dataset-pivot-table > div > div"
      ).style = "overflow-x: visible !important";

      document
        .getElementById("tabel-dinamis-html-pdf-container")
        .appendChild(
          document
            .getElementById("tabel-dinamis-choosen-dataset-info")
            .cloneNode(true)
        );

      document
        .getElementById("tabel-dinamis-html-pdf-container")
        .appendChild(
          document
            .getElementById("tabel-dinamis-visualization-table-metadata")
            .cloneNode(true)
        );

      let filename = this.filename;

      let doc = new jsPDF({
        orientation: "p",
        unit: "px",
        hotfixes: ["px_scaling"],
        size: "a4",
      });
      html2canvas(
        document.getElementById("tabel-dinamis-html-pdf-container")
      ).then(function (canvas) {
        document.getElementById("tabel-dinamis-html-pdf-container").innerHTML =
          "";
        document
          .getElementById("tabel-dinamis-html-pdf-container2")
          .appendChild(canvas);

        doc.addImage(
          canvas.toDataURL("image/png"),
          "PNG",
          20,
          20,
          750,
          1075,
          ""
          // ,
          // "SLOW"
        );
        document.getElementById("tabel-dinamis-html-pdf-container2").innerHTML =
          "";

        doc.save(filename + ".pdf");
      });
    },

    /*xml methods section*/
    downloadXML() {
      let data,
        xmlFile,
        xmlFilename,
        xmlType,
        xmlSubtype,
        zipFile = new jszip();

      //data-xml
      data = Object.values(this.choosenData).map((item) => {
        return item;
      });
      xmlType = "data";
      xmlSubtype = "datum";
      xmlFilename = "(data) " + this.filename + ".xml";
      xmlFile = this.constructXMLFile(
        data,
        xmlType,
        xmlSubtype,
        xmlFilename,
        zipFile
      );

      //subject-metadata-xml
      data = [this.subjectMetadata];
      xmlType = "subject-metadata";
      xmlSubtype = "subject";
      xmlFilename = "(metadata subjek) " + this.filename + ".xml";
      xmlFile = this.constructXMLFile(
        data,
        xmlType,
        xmlSubtype,
        xmlFilename,
        zipFile
      );

      //dataset-metadata-xml
      data = [this.datasetMetadata];
      xmlType = "dataset-metadata";
      xmlSubtype = "dataset";
      xmlFilename = "(metadata dataset) " + this.filename + ".xml";
      xmlFile = this.constructXMLFile(
        data,
        xmlType,
        xmlSubtype,
        xmlFilename,
        zipFile
      );

      //indicator-metadata-xml
      data = this.indicatorMetadata;
      xmlType = "indicator-metadata";
      xmlSubtype = "indicator";
      xmlFilename = "(metadata indikator) " + this.filename + ".xml";
      xmlFile = this.constructXMLFile(
        data,
        xmlType,
        xmlSubtype,
        xmlFilename,
        zipFile
      );

      //dimension-metadata-xml
      data = this.dimensionMetadata;
      xmlType = "dimension-metadata";
      xmlSubtype = "dimension";
      xmlFilename = "(metadata dimensi) " + this.filename + ".xml";
      xmlFile = this.constructXMLFile(
        data,
        xmlType,
        xmlSubtype,
        xmlFilename,
        zipFile
      );

      this.generateZipFile(xmlFile, "xml", zipFile);
    },
    constructXMLFile(data, type, subtype, filename, zipFile) {
      let blob, xmlContent;

      xmlContent = '<?xml version="1.0" encoding="UTF-8"?><tabel_dinamis>';
      xmlContent += "<" + type + ">";

      if (Array.isArray(data)) {
        data.forEach((value) => {
          xmlContent += "<" + subtype + ">";
          xmlContent += this.OBJtoXML(value);
          xmlContent += "</" + subtype + ">";
        });
      }

      xmlContent += "</" + type + "></tabel_dinamis>";

      blob = new Blob(["\ufeff", xmlContent]);

      return zipFile.file(filename, blob);
    },
    OBJtoXML(obj) {
      let xml = "";

      Object.entries(obj).forEach(([key, value]) => {
        if (typeof value !== "object") {
          xml += "<" + key + ">" + value + "</" + key + ">";
        } else if (typeof value === "object" && value == null) {
          xml += "<" + key + " />";
        } else if (
          typeof value === "object" &&
          value != null &&
          !Array.isArray(value)
        ) {
          xml += "<" + key + ">" + this.OBJtoXML(value) + "</" + key + ">";
        } else if (
          typeof value === "object" &&
          value != null &&
          Array.isArray(value)
        ) {
          xml += "<" + key + ">";
          value.forEach((value2) => {
            xml += "<item>" + this.OBJtoXML(value2) + "</item>";
          });
          xml += "</" + key + ">";
        }
      });

      xml = xml.replace(/<\/?[0-9]{1,}>/g, "");

      return xml;
    },

    updateIsFreeze(val) {
      this.$emit("update:isFreeze", val.value);
    },

    updateIsStripped(val) {
      this.$emit("update:isStripped", val.value);
    },

    updateIsHighlighted(val) {
      this.$emit("update:isHighlighted", val.value);
    },

    updateFontSize(val) {
      this.$emit("update:fontSize", val);
    },

    updateTableTheme(val) {
      this.$emit("update:tableTheme", val);
    },

    resetTable() {
      this.updateIsFreeze(false);
      this.updateTableTheme("blue");
      this.updateFontSize("m");
      this.updateIsStripped(false);
      this.updateIsHighlighted(false);

      this.$emit("update:doSum", false);
      this.$emit("update:doAverage", false);
      this.$emit("update:doMinimum", false);
      this.$emit("update:doMaximum", false);
      this.$emit("update:doMedian", false);
      this.$emit("update:doCount", false);
      this.$emit("update:doStandardDeviation", false);

      this.$emit("update:doMinimumX", false);
      this.$emit("update:doMaximumX", false);
      this.$emit("update:doMinimumY", false);
      this.$emit("update:doMaximumY", false);

      this.updateChoosenRowFields(["region"]);

      let tempChoosenColumnFields = ["indicator", "period"];
      Object.keys(this.choosenDimensions).forEach((key) => {
        if (
          key.startsWith("category") &&
          this.choosenDimensions[key].selectedItem.length > 0
        ) {
          tempChoosenColumnFields.push(key);
        }
      });
      this.updateChoosenColumnFields(tempChoosenColumnFields);

      this.updateIsNeedReloaded(true);
    },
    toggleMetadata() {
      this.$emit("update:showMetadata", !this.showMetadata);
    },
    toggleDoSum(val) {
      this.$emit("update:doSum", val.value);
    },
    toggleDoAverage(val) {
      this.$emit("update:doAverage", val.value);
    },
    toggleDoMinimum(val) {
      this.$emit("update:doMinimum", val.value);
    },
    toggleDoMaximum(val) {
      this.$emit("update:doMaximum", val.value);
    },
    toggleDoMedian(val) {
      this.$emit("update:doMedian", val.value);
    },
    toggleDoCount(val) {
      this.$emit("update:doCount", val.value);
    },
    toggleDoStandardDeviation(val) {
      this.$emit("update:doStandardDeviation", val.value);
    },

    toggleDoMinimumX(val) {
      this.$emit("update:doMinimumX", val.value);
    },
    toggleDoMaximumX(val) {
      this.$emit("update:doMaximumX", val.value);
    },
    toggleDoMinimumY(val) {
      this.$emit("update:doMinimumY", val.value);
    },
    toggleDoMaximumY(val) {
      this.$emit("update:doMaximumY", val.value);
    },

    generateTd(tdContent) {
      return "<td>" + tdContent + "</td>";
    },
  },
  components: {
    "visualization-fields-layouting-modal": VisualizationFieldsLayoutingModal,
  },
};
</script>

<!-- css section-->
<style lang="scss" scoped>
@import "src/assets/scss/_table-dinamis";
</style>

<!-- author: m.	nif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 23-09-2022 -->
